import { GRID_NAMES } from 'constants/index';
import { getGridAction } from '../lib/gridActionCreator';

export const saveClearingGrid = getGridAction(GRID_NAMES.CLEARING);
